import { render } from "./SeAiman.vue?vue&type=template&id=5f08bcc1"
import script from "./SeAiman.vue?vue&type=script&lang=js"
export * from "./SeAiman.vue?vue&type=script&lang=js"

import "./SeAiman.vue?vue&type=style&index=0&id=5f08bcc1&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__